(() => {
  function init(root) {
    if (!root || root.dataset.filmReady) return;
    root.dataset.filmReady = 'true';
    const video = root.querySelector('.ch-herocar__film');
    if (!video) return;
    const slide = video.closest('.ch-herocar__slide');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    // No play/pause control any more: the film runs itself. It still stops
    // when its slide is not the open one, when the hero scrolls out of view,
    // when the tab is hidden, and when the visitor asks for reduced motion.
    let suppressed = reduced.matches;
    let visible = true;
    video.id = `HomeFilm-${root.closest('.shopify-section').id}`;
    video.muted = true;
    video.setAttribute('playsinline', '');
    function sync() {
      const active = slide.getAttribute('aria-hidden') !== 'true';
      if (active && visible && !document.hidden && !suppressed) {
        video.play().catch(() => {});
      } else video.pause();
    }
    document.addEventListener('visibilitychange', sync);
    reduced.addEventListener('change', () => { suppressed = reduced.matches; sync(); });
    const mutation = new MutationObserver(sync);
    mutation.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
    observer.observe(root);
    sync();
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      mutation.disconnect(); observer.disconnect(); video.pause();
      document.removeEventListener('visibilitychange', sync);
    }, { once: true });
  }
  init(document.querySelector('#home'));
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('#home')));
})();
